"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyQuestionToJSON = exports.SurveyQuestionFromJSONTyped = exports.SurveyQuestionFromJSON = exports.instanceOfSurveyQuestion = exports.SurveyQuestionSelectionTypeEnum = void 0;
var runtime_1 = require("../runtime");
var SurveyOption_1 = require("./SurveyOption");
/**
 * @export
 */
exports.SurveyQuestionSelectionTypeEnum = {
    SingleSelect: 'SINGLE_SELECT',
    MultiSelect: 'MULTI_SELECT'
};
/**
 * Check if a given object implements the SurveyQuestion interface.
 */
function instanceOfSurveyQuestion(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyQuestion = instanceOfSurveyQuestion;
function SurveyQuestionFromJSON(json) {
    return SurveyQuestionFromJSONTyped(json, false);
}
exports.SurveyQuestionFromJSON = SurveyQuestionFromJSON;
function SurveyQuestionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'selectionType': !(0, runtime_1.exists)(json, 'selection_type') ? undefined : json['selection_type'],
        'primaryText': !(0, runtime_1.exists)(json, 'primary_text') ? undefined : json['primary_text'],
        'secondaryText': !(0, runtime_1.exists)(json, 'secondary_text') ? undefined : json['secondary_text'],
        'options': !(0, runtime_1.exists)(json, 'options') ? undefined : (json['options'].map(SurveyOption_1.SurveyOptionFromJSON)),
        'lastSurveyOption': !(0, runtime_1.exists)(json, 'last_survey_option') ? undefined : (0, SurveyOption_1.SurveyOptionFromJSON)(json['last_survey_option']),
        'randomizeSurveyOptions': !(0, runtime_1.exists)(json, 'randomize_survey_options') ? undefined : json['randomize_survey_options'],
        'language': !(0, runtime_1.exists)(json, 'language') ? undefined : json['language'],
    };
}
exports.SurveyQuestionFromJSONTyped = SurveyQuestionFromJSONTyped;
function SurveyQuestionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'selection_type': value.selectionType,
        'primary_text': value.primaryText,
        'secondary_text': value.secondaryText,
        'options': value.options === undefined ? undefined : (value.options.map(SurveyOption_1.SurveyOptionToJSON)),
        'last_survey_option': (0, SurveyOption_1.SurveyOptionToJSON)(value.lastSurveyOption),
        'randomize_survey_options': value.randomizeSurveyOptions,
        'language': value.language,
    };
}
exports.SurveyQuestionToJSON = SurveyQuestionToJSON;
